import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const DownloadIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g>
        <path d='m12 17c-.276 0-.5-.224-.5-.5v-16c0-.276.224-.5.5-.5s.5.224.5.5v16c0 .276-.224.5-.5.5z' />
      </g>
      <g>
        <path d='m12 17c-.128 0-.256-.049-.354-.146l-4-4c-.195-.195-.195-.512 0-.707s.512-.195.707 0l3.647 3.646 3.646-3.646c.195-.195.512-.195.707 0s.195.512 0 .707l-4 4c-.097.097-.225.146-.353.146z' />
      </g>
      <g>
        <path d='m21.5 24h-19c-1.379 0-2.5-1.122-2.5-2.5v-5c0-.276.224-.5.5-.5s.5.224.5.5v5c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-5c0-.276.224-.5.5-.5s.5.224.5.5v5c0 1.378-1.121 2.5-2.5 2.5z' />
      </g>
    </svg>
  );
};
